import Restful from "./Restful";
import Cookies from "universal-cookie/lib"
import store from "src/redux/store";
import SystemActions from "src/redux/actions/SystemActions";
import jwt from 'jsonwebtoken';

const keyToken = "saa-authentication";
const cookies = new Cookies();

export default class Authentication {
    public static signIn(user: string, password: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            const restful = new Restful();
            const object = {
                username: user,
                password: password
            };
            restful.post('/login', object).then(response => {
                cookies.set(keyToken, response.body);
                store.dispatch(SystemActions.SET_AUTHENTICATION(true));
                resolve(response.message);
            }).catch(reason => {
                reject(reason.message);
            });
        });
    }

    public static getToken(): string {
        return cookies.get(keyToken);
    }

    public static async signOut(): Promise<void> {
        cookies.remove(keyToken);
        window.location.reload();
    }

    public static isAuth(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const token = this.getToken();
            if (token) {
                jwt.verify(token, process.env.REACT_APP_PRIVATE_KEY, (err, decoded) => {
                    if (err) {
                        reject(false);
                        return;
                    }
                    resolve(true);
                });
            } else {
                reject(false);
            }
        });
    }
}
